import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-datepicker', 'chooseDate', 'Choose date');
Labels.set('ui-datepicker', 'selectedDate', 'Selected date');
Labels.set('ui-datepicker', 'close', 'Close');
Labels.set('ui-datepicker', 'clear', 'Clear input');
